<script lang="ts" setup>
import { SancareSticky } from '@sancare/typescript-commons'
import { computed } from 'vue'

import AdminStayHeader from '@/stay-displayer/common/AdminStayHeader.vue'
import PatientCard from '@/stay-displayer/common/PatientCard.vue'
import McoRumCard from '@/stay-displayer/mco/McoRumCard.vue'
import McoStayCardCh from '@/stay-displayer/mco/McoStayCardCh.vue'
import McoStayCardFr from '@/stay-displayer/mco/McoStayCardFr.vue'
import { useStore } from '@/store'
import { CountryEnum, PmsiTypeEnum } from '@/store/modules/settings/types'
import { McoStay, McoStayCh, RumFr } from '@/store/modules/stay/mco/types'

const store = useStore()

const props = defineProps<{
  stay: McoStay
  displayedRumId: number
}>()

const pmsiCountry = computed(() => store.state.settings.pmsi.country)
const pseudonymizationEnabled = computed(() => store.getters.flatSancareSettings['enable_pseudonymization'])
const fullName = computed(() => store.getters.fullName)

const stayRums = computed(() => props.stay.rums.filter((rum) => rum.id > 0))
const displayedRum = computed(() => stayRums.value.find((rum) => rum.id === props.displayedRumId) ?? stayRums.value[0] ?? null)
const displayedRumIndex = computed(() => displayedRum.value
  ? stayRums.value.findIndex((rum) => rum.id === displayedRum.value!.id)
  : -1)
</script>

<template>
  <sancare-sticky class="patient-data-container">
    <div class="general-stay-data card mb-3">
      <div class="card-body">
        <div class="data-table">
          <div class="mb-3">
            <admin-stay-header
              :stay-id="stay.id"
              :administrative-local-stay-id="String(stay.administrativeLocalStayId)"
              :pmsi-id="stay.rssId"
              :pmsi-type="PmsiTypeEnum.MCO"
            />
          </div>

          <div class="row g-4">
            <div class="col">
              <patient-card
                :patient="stay.patient"
                :patient-age="stay.patientAge"
                :full-name="fullName"
                :pseudonymization-enabled="pseudonymizationEnabled"
              />
            </div>

            <template v-if="pmsiCountry === CountryEnum.CH">
              <div class="col-8">
                <mco-stay-card-ch :stay="(stay as McoStayCh)" />
              </div>
            </template>
            <template v-else>
              <div class="col">
                <mco-stay-card-fr :stay="stay" />
              </div>
              <div
                v-if="displayedRum"
                class="col"
              >
                <mco-rum-card
                  :rum="(displayedRum as RumFr)"
                  :rum-index="displayedRumIndex"
                />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </sancare-sticky>
</template>

<style lang="scss">
.patient-data-container {
  .sticky {
    z-index: 9;

    .general-stay-data {
      background-color: white;
    }
  }

  .sticky.fixing {
    .general-stay-data {
      box-shadow: 1px 2px 3px rgba(0, 0, 0, .3);
    }
  }
}
</style>

<style scoped lang="scss">
h1 {
  font-size: 1.5rem;
}
</style>
